module.exports = __webpack_public_path__ + "img/bg_m.e9f1e4ef.jpg";